var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":"https://img3.quanyou.com.cn/joyNew/group1/M00/26/94/rB8LrWWDydWAGSG9AAVhXhKCBjI150.png","alt":""}})])}]

export { render, staticRenderFns }